module.exports = "pegasus_template/assets/circle-snapchat.png";